import { Action, Resource } from '@topconagriculture/permissions';

export enum DataToolsType {
  LoadsDeliveries = 'loadsdeliveries',
  IngredientPrices = 'ingredientprices',
  MilkProduction = 'milkproduction',
  ExternalConcentrate = 'externalconcentrates',
  MilkPrice = 'milkprices',
  PenSettingChanges = 'groupchanges',
  RationSettingChanges = 'rationchanges',
  IngredientSettingChanges = 'ingredientchanges',
  IngredientPriceSettingChanges = 'ingredientpricechanges',
  IngredientDryMatterSettingChanges = 'ingredientdrymatterchanges',
  IngredientInventoryChanges = 'inventoryhistory',
}

export enum BaseDataToolsType {
  LoadsDeliveries = 'loadsdeliveries',
  IngredientPrices = 'ingredientprices',
}

export const baseDataToolsPermissionMap = {
  [DataToolsType.LoadsDeliveries]: {
    resource: Resource.FEED_DATA_TOOLS_LOADSDELIVERIES,
    action: Action.READ,
  },
  [DataToolsType.IngredientPrices]: {
    resource: Resource.FEED_DATA_TOOLS_INGREDIENTPRICES,
    action: Action.READ,
  },
};

export const dataToolsPermissionMap = {
  ...baseDataToolsPermissionMap,
  [DataToolsType.MilkProduction]: {
    resource: Resource.FEED_DATA_TOOLS_MILKPRODUCTION,
    action: Action.READ,
  },
  [DataToolsType.ExternalConcentrate]: {
    resource: Resource.FEED_DATA_TOOLS_EXTERNALCONCENTRATES,
    action: Action.READ,
  },
  [DataToolsType.MilkPrice]: {
    resource: Resource.FEED_DATA_TOOLS_MILKPRICE,
    action: Action.READ,
  },
  [DataToolsType.PenSettingChanges]: {
    resource: Resource.FEED_REPORTS_GROUPCHANGES,
    action: Action.REPORT_READ,
  },
  [DataToolsType.RationSettingChanges]: {
    resource: Resource.FEED_REPORTS_RATIONCHANGES,
    action: Action.REPORT_READ,
  },
  [DataToolsType.IngredientSettingChanges]: {
    resource: Resource.FEED_REPORTS_INGREDIENTCHANGES,
    action: Action.REPORT_READ,
  },
  [DataToolsType.IngredientPriceSettingChanges]: {
    resource: Resource.FEED_REPORTS_INGREDIENTPRICECHANGES,
    action: Action.REPORT_READ,
  },
  [DataToolsType.IngredientDryMatterSettingChanges]: {
    resource: Resource.FEED_REPORTS_INGREDIENTDRYMATTERCHANGES,
    action: Action.REPORT_READ,
  },
  [DataToolsType.IngredientInventoryChanges]: {
    resource: Resource.FEED_REPORTS_INVENTORY_HISTORY,
    action: Action.REPORT_READ,
  },
};
